import React from "react";
import axios from 'axios';

import "./ListaHistoricoHardware.css";
import verificandoToken from '../../../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../../../config/backend';

function ListaHistoricoHardware(props) {

    const formatarDataHoraBrasileira = (dataHora) => {
        const data = new Date(dataHora);
        return data.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    };

    const deleteHistoricoHardware = async (seqHis) => {

        let confirmacao = window.confirm("Você realmente deseja excluir o histrocio " + seqHis + "?");

        verificandoToken();

        const token = localStorage.getItem('token');

        if (confirmacao) {
            try {

                await axios.delete(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hishardware", {
                    headers: {
                        Authorization: `${token}`
                    },
                    data: {
                        seqHis
                    }
                });

                alert("Historico de hardware " + seqHis + " deletado com sucesso!");

                window.location.reload();

            } catch (error) {
                console.error('Erro:', error);
            }
        }
    };

    return (

        <table className="table table-modern align-middle">
            <thead>
                <tr>
                    <th scope="col" >Sequência</th>
                    <th scope="col" >Descrição</th>
                    <th scope="col" >Hardware</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.arrayHistoricoHardware.map((hardware) => {
                    return (
                        <tr key={hardware.id}>
                            <td>{hardware.seqhis}</td>
                            <td style={{ whiteSpace: 'pre-line' }}>{hardware.deshis}</td>
                            <td>{hardware.codhar}</td>
                            <td>{formatarDataHoraBrasileira(hardware.dathis)}</td>
                            <td>
                                <button className="btn btn-danger" onClick={() => deleteHistoricoHardware(hardware.seqhis)} type="button"><i className="fas fa-trash" aria-hidden="true"></i></button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>

    );
}

export default ListaHistoricoHardware;
